import { hideDoors } from 'ducks/layout';
import { BehaviorParameters } from 'rangeConfig/@types';

const hideDoorsBehavior = ({ dispatch }: BehaviorParameters) => {
  dispatch(hideDoors());
};

export default hideDoorsBehavior;
